import { Injectable, Injector } from '@angular/core';
import { Role } from '@common/core/models/role.model';
import { IBitfApiResponse } from '@common/libs/bitforce/core/services/api/bitf-api.interface';
import { BitfApiService } from '@common/libs/bitforce/core/services/api/bitf-api.service';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersPermissionsService extends BitfApiService {
  constructor(public injector: Injector) {
    super('users-permissions', injector);
  }

  getRoles(): Observable<IBitfApiResponse<Role[]>> {
    return (
      super
        .get<Role>({
          path: '/roles',
          method: 'GET',
          modelMapper: 'role',
          disableHideLoader: true,
        })
        // NOTE: the response has 'roles' property containing the array of roles
        .pipe(tap((response: any) => (response.content = response.content?.roles || [])))
    );
  }
}
